import React from "react";
import Card from "react-bootstrap/Card";

function ServicesCards({ imgPath, icon, title, description }) {
  return (
    <Card className="project-card-view">
      {/* Render icon if provided, otherwise fallback to image */}
      {icon ? (
        <div style={{ fontSize: "3rem", color: "#c62828", margin: "20px auto 0", textAlign: "center" }}>
          {icon}
        </div>
      ) : (
        <Card.Img variant="top" src={imgPath} alt="card-img" />
      )}
      
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default ServicesCards;
